import React from "react";
import "../../assets/styles/components/_login.scss";
import useForm from "../../hooks/useForm";
import useLogin from "../../hooks/useLogin";
import toast from "react-hot-toast";
import { ROLES_CLIENTES } from "../../helpers/constants";
import { useState } from "react";
import { useLocation } from "react-router";
import tensoliteLogoLogin from "../../assets/images/brand/TENSOLITE.svg"
import tensoliteCalculadora from "../../assets/images/brand/CALCULADORA.svg"
import correoIcon from "../../assets/images/icons/CORREO.svg"
import passwordIcon from "../../assets/images/icons/CONTRASENA.svg"
import eyeIcon from "../../assets/images/icons/OJO.svg"

const LoginClienteCard = () => {
  const {
    values,
    handleInputChange,
    emailError,
    passwordError,
    errorEmailInput,
    errorPasswordInput,
  } = useForm({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const { handleSubmit } = useLogin();

  const MostrarMensajeError = (event) => {
    toast.error("Email y/o contraseña incorrectos");
    event.preventDefault();
  };

  const VerificarCampos = (event, values) => {
    !emailError && !passwordError
      ? handleSubmit(event, values, queryParams.toString().length > 0 ? `/calculadora-losa-con-viguetas?${queryParams.toString()}` : "/calculadora-losa-con-viguetas", ROLES_CLIENTES)
      : MostrarMensajeError(event);
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="container">
      <div className="text-login py-3">
        <div className="calculatorText">
          <img src={tensoliteCalculadora} alt="Logo Calculadora" className="logoLogin" />
          <h3>CALCULADORA</h3>
        </div>
        <img src={tensoliteLogoLogin} alt="Logo Tensolite" className="logoLogin" />
      </div>
      <form
        className="container login__card-form OnlyBottomBorderRadius"
        onSubmit={(event) => VerificarCampos(event, values)}
      >
        <h1 className="hiText" >¡Hola!</h1>
        <p className="textRegister"><strong>Inicia sesión</strong> o <a className="linkToRegister" href="/clientes/registro">registrate gratis</a> para visualizar los resultados de tu cálculo. </p>
        <div className="d-flex flex-column gap-3 w-100">
          <div className={` inputNoEye ${errorEmailInput ? "input-error" : ""}`}>
            <img src={correoIcon} alt="Correo" className="inputIcon" />
            <input
              type="text"
              id="email"
              name="email"
              placeholder="E-mail"
              className="inputLogin"
              value={values.email}
              onChange={handleInputChange}
            />
          </div>
          <div className={` inputNoEye ${errorPasswordInput ? "input-error" : ""}`}>
            <img src={passwordIcon} alt="passwordIcon" className="inputIcon" />
            <input
              maxLength={12}
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Contraseña"
              className="inputLogin"
              value={values.password}
              onChange={handleInputChange}
            />
            <img src={eyeIcon} alt="eyeIcon" className="inputIcon eyeIcon" onClick={toggleShowPassword} />
          </div>
          <input type="submit" className="button--submit" value="INGRESAR" />
        </div>
        <a className="linkToRecoveryPassword" href="/clientes/olvide-password">¿Olvidaste tu contraseña?</a>
        <p className="textFooterLogin">¿No tienes cuenta? <a className="registerFooter" href={queryParams.toString().length > 0 ? `/clientes/registro?${queryParams.toString()}` : "/clientes/registro"}>
          Regístrate haciendo click aquí</a>
        </p>
      </form>
    </div>
  );
};

export default LoginClienteCard;
